<div class="addDebitContainer" id="addDebitContainer">
  <h1 class="addDebitTitle" id="addDebitTitle">
    Automatiza tus pagos vinculando una de tus cuentas de ahorros
  </h1>
  <div class="addDebitAccountsContainer" id="addDebitAccountsContainer">
    <label
      for="addDebitEntitySelect"
      class="addDebitLabels"
      id="addDebitEntityLabel"
    >
      <h1>Banco o entidad financiera</h1>
      <select
        name="addDebitEntitySelect"
        id="addDebitEntitySelect"
        [(ngModel)]="entitySelected"
        class="addDebitSelects"
      >
        <option [ngValue]="null" disabled selected>
          Selecciona una entidad
        </option>
        <option *ngFor="let entity of entitys" [ngValue]="entity">
          {{ entity.Nombre }}
        </option>
      </select>
    </label>
    <label
      for="addDebitTypeSelect"
      class="addDebitLabels"
      id="addDebitTypeLabel"
    >
      <h1>Tipo de cuenta</h1>
      <select
        name="addDebitTypeSelect"
        id="addDebitTypeSelect"
        [(ngModel)]="typeSelected"
        class="addDebitSelects"
      >
        <option [ngValue]="null" disabled selected>
          Selecciona el tipo de cuenta
        </option>
        <option *ngFor="let type of typeList" [ngValue]="type">
          {{ type.name }}
        </option>
      </select>
    </label>
    <label
      for="addDebitNumberSelect"
      class="addDebitLabels"
      id="addDebitNumberLabel"
    >
      <h1>Número de cuenta</h1>
      <input
        type="text"
        class="addDebitSelects"
        id="addDebitNumberSelect"
        placeholder="1234567890"
        [(ngModel)]="numberSelect"
      />
    </label>
    <label for="addDebitCheck" class="addDebitCheck" id="addDebitCheck">
      <input
        type="checkbox"
        id="addDebitCheck"
        value="addDebitCheck"
        [(ngModel)]="addDebitCheck"
      />
      <p>
        <b>
          Autorizo que realice la automatización del débito automático de mi
          cuenta
        </b>
        para el pago de las cuotas del crédito.
      </p>
    </label>
  </div>
  <div class="addDebitButtonsGroup" id="addDebitButtonsGroup">
    <button
      class="addDebitSaveButton"
      id="addDebitSaveButton"
      [disabled]="
        !addDebitCheck || !entitySelected || !typeSelected || !numberSelect
      "
      (click)="handleSelectedDebit()"
    >
      Guardar
    </button>
    <button
      class="addDebitCancelButton"
      id="addDebitCancelButton"
      (click)="handleStepsCredit(1)"
    >
      Cancelar
    </button>
  </div>
</div>
